import script from "./ProvinciaSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProvinciaSelector.vue?vue&type=script&setup=true&lang=ts"

import "./ProvinciaSelector.vue?vue&type=style&index=0&id=3a4f7121&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a4f7121"]])

export default __exports__